import useSWR from "swr";
import useDealerId from "hooks/useDealerId";
import DealerInventoryUploadService from "services/DealerInventoryUploadService";

export default function useDealerInventoryLog() {
    const dealerId = useDealerId();

    const shouldFetch = Boolean(dealerId);
    const key = shouldFetch ? ["dealer-inventory-log", dealerId] : null;

    const fetcher = async () => {
        const response = await DealerInventoryUploadService.getLog(dealerId);
        return response;
    };

    const { data, error, isLoading, mutate } = useSWR(key, fetcher, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: 60000,
    });

    return {
        log: data,
        isLoading,
        error,
        refresh: mutate,
    };
}
